/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateInvoicesResponse
 */
export interface GenerateInvoicesResponse {
    /**
     * 
     * @type {number}
     * @memberof GenerateInvoicesResponse
     */
    generated: number;
}

/**
 * Check if a given object implements the GenerateInvoicesResponse interface.
 */
// @ts-ignore
export function instanceOfGenerateInvoicesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "generated" in value;

    return isInstance;
}

// @ts-ignore
export function GenerateInvoicesResponseFromJSON(json: any): GenerateInvoicesResponse {
    return GenerateInvoicesResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function GenerateInvoicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInvoicesResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generated': json['generated'],
    };
}

// @ts-ignore
export function GenerateInvoicesResponseToJSON(value?: GenerateInvoicesResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generated': value.generated,
    };
}

